<template>
    <a :href="itemLink(item)" :data-id="item.id" :class="itemClass(item)">

        <i class="material-icons">{{ learning_unit_icons[item.type] }}</i>
        
        <div class="trax-top-left-icon">
            <i class="material-icons" v-if="item.meta.remedial">replay</i>
        </div>

    </a>
</template>

<script>
    export default {

        props: {

            id: null,
            bus: null,
            item: {
                type: Object,
                required: true
            },
            states: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                learning_unit_icons: data.learning_unit_icons,
                app_url: app_url,
                registration: data.registration,
                learner: data.learner,
            }
        },

        methods: {

            itemLink(item) {
                return this.app_url + 'polaris/ui/atpl-dashboard/registration/' + this.registration.id + '/' + item.type + '/' + item.id + '/learner/' + this.learner.id;
            },

            itemClass(item) {
                var color_status = this.states[item.id] ? this.states[item.id].color_status : 'default';
                return 'picto btn btn-'+color_status;
            },
        }
    }
</script>

<style scoped>

    .picto {
        padding: .5rem .4rem .5rem .6rem;
    }
    .trax-top-left-icon {
        position: absolute;
        top: -2px;
        left: 0px;
    }
    .trax-top-left-icon i {
        font-size: 12px;
    }

</style>
